import { useMemo } from 'react';

export function useLocalFilteredResults(dataset, query) {
  return useMemo(() => {
    return dataset.filter((item) =>
      JSON.stringify(item).toLowerCase().includes(query.toLowerCase()),
    );
  }, [dataset, query]);
}
